export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBEGcQ5Ukfpv0uPfcv4bGsCObOM76X1mhA",
    authDomain: "mapdec.firebaseapp.com",
    databaseURL: "https://mapdec.firebaseio.com",
    projectId: "mapdec",
    storageBucket: "mapdec.appspot.com",
    messagingSenderId: "112540364348",
    appId: "1:112540364348:web:c1f2af361fb93ff96ddd39",
    measurementId: "G-TL9WFS2VE9"
  },
  googleClientId: "845839389008-s0scp3mghdi67t5ga9t56j6265ibonp5.apps.googleusercontent.com"
};